'use client';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';
import { Skeleton } from '../../skeleton';

import styles from './LineChart.Skeleton.module.scss';

export type LineChartSkeletonProps = BaseComponentProps & {
  labels: number;
};

function LineChartSkeleton({
  style,
  className,
  labels,
}: LineChartSkeletonProps) {
  return (
    <div style={style} className={classnames(styles['main'], className)}>
      <Skeleton className={styles['plot']} />
      <div className={styles['legend']}>
        {Array.from(Array(labels)).map((_, index) => (
          <Skeleton className={styles['legend__item']} width={70} key={index} />
        ))}
      </div>
    </div>
  );
}

export { LineChartSkeleton };
